import styled from "@emotion/styled"

const PostListItemHeader = styled.span`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.breakpoints.down("lg")} {
    margin-bottom: 10px;
    gap: 10px;
  }

  ${({ theme }) => theme.breakpoints.between("md", "xl")} {
    justify-content: space-between;
    margin-bottom: 29px;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    justify-content: space-between;
    margin-bottom: 4px;
  }
`

export default PostListItemHeader
